<template>
  <div
    class="tracking-normal transition cursor-pointer hover:bg-neutral-100 rounded px-3 py-2 focus:outline-none focus:bg-neutral-100 hidden md:flex flex-col"
    :class="{ 'scale-105 transform': visible }"
    tabindex="0"
    aria-hidden="true"
    @click="$emit('toggle')"
    @keypress.space="$emit('toggle')"
  >
    <div
      class="text-sm font-medium transition ease-in-out duration-500 shrink-0 hidden md:block"
      :class="{
        'text-neutral-800 hover:text-neutral-900': !filtersSelected,
        'text-neutral-300': !visible && filtersSelected,
      }"
      aria-hidden="true"
    >
      {{ label }}
    </div>
    <div
      class="transition ease-in-out duration-500 flex items-center mt-1"
      :class="{
        'text-neutral-500 hover:text-neutral-900': !filtersSelected,
        'opacity-25': !visible && filtersSelected,
      }"
    >
      <span class="shrink-0">
        <slot />
      </span>

      <fa
        class="ml-2"
        :icon="['fal', 'angle-down']"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'VetsterSearchInput',

  props: {
    label: {
      required: true,
      type: String,
    },
    visible: {
      required: true,
      type: Boolean,
    },
    filtersSelected: {
      required: true,
      type: Boolean,
    },
  },
};
</script>
